import { Translate } from 'next-translate';

export const getTranslateFromLogicalValue = (value: string, t: Translate): string => {
    return value === '1' ? t('Yes') : t('No');
};
